import "./Tabs.css";
import { useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";

export default function Tabs({
  tabs = [
    {
      id: "id1",
      title: "Banking",
      to: "/vault/banking",
      hidden: false,
    },
    {
      id: "id2",
      title: "Finance",
      to: "/vault/finance",
      hidden: false,
    },
  ],
  selectedID = "",
  onSelect,
  smallTabs = false,
}) {
  const tabsContainerRef = useRef(null);
  const location = useLocation();

  // To be refactored
  useEffect(() => {
    if (tabsContainerRef.current) {
      const activeNavLink = tabsContainerRef.current.querySelector(
        `a.Tab[href="${location.pathname}"]`,
      );

      const activeDivTab =
        tabsContainerRef.current.querySelector(".Tab.active");

      const activeTabElement = activeNavLink || activeDivTab;

      if (activeTabElement) {
        activeTabElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  }, [location.pathname, selectedID]);
  // End to be refactored

  return (
    <nav
      ref={tabsContainerRef}
      className={["Tabs", smallTabs ? "smallTabs" : ""]
        .filter(Boolean)
        .join(" ")}
    >
      {tabs
        .filter((tab) => !tab.hidden)
        .map((tab, index) => {
          const { to, title, id } = tab;
          if (to) return <NavTab key={index} title={title} to={to} />;
          return (
            <Tab
              key={index}
              title={title}
              active={id === selectedID}
              onClick={() => onSelect(id)}
            />
          );
        })}
    </nav>
  );
}

function NavTab({ title, to }) {
  return (
    <NavLink
      className={({ isActive }) =>
        ["Tab", isActive && "active"].filter(Boolean).join(" ")
      }
      to={to}
    >
      {title}
    </NavLink>
  );
}

function Tab({ title, active, onClick }) {
  return (
    <div
      onClick={onClick}
      className={["Tab", active && "active"].filter(Boolean).join(" ")}
    >
      {title}
    </div>
  );
}
